// 261010 UI1a — MỘT nút chính cỡ lớn theo tình huống (`primaryActionOf`). Chỉ vẽ: không gọi API. Nút tắt luôn kèm chú thích. Không hiện giá.
import React from 'react';
import type { PrimaryAction, PrimaryCall } from './workflowPrimaryPolicy';
import WfIcon from './WfIcon';
import { primaryIconOf } from './workflowStatusIcons';

interface Props { action: PrimaryAction; sending: boolean; onRun: (call: PrimaryCall | null) => void; /** UI1c: bản gọn trong thanh dính (không id, không liên kết phụ, lý do ở tooltip). */ compact?: boolean }

const WorkflowPrimaryBar: React.FC<Props> = ({ action, sending, onRun, compact }) => (
  <div className={compact ? 'wf-primary compact' : 'wf-primary'} {...(compact ? {} : { id: 'wf-primary' })} data-testid={compact ? 'wf-primary-compact' : 'wf-primary'}>
    <button type="button" className={`wf-pbtn ${action.tone}`} disabled={!action.enabled} aria-busy={sending} title={action.enabled ? undefined : action.reason}
      onClick={() => onRun(action.call)} data-testid={compact ? 'wf-primary-btn-compact' : 'wf-primary-btn'} data-key={action.key} data-waiting={action.waiting ? 'true' : undefined}>
      {sending || action.waiting ? <WfIcon name="loading" /> : (primaryIconOf(action.key) ? <WfIcon name={primaryIconOf(action.key)!} /> : null)}{action.label}
    </button>
    {compact ? null : action.secondary.map((a) => (
      <button key={a.key} type="button" className="wf-plink" disabled={!a.enabled || sending} title={a.enabled ? undefined : a.reason} onClick={() => onRun(a.call)} data-testid={`wf-primary-sec-${a.key}`}>{a.label}</button>
    ))}
    {!compact && !action.enabled && action.reason ? <div className={action.waiting ? 'wf-pwhy wait' : 'wf-pwhy'} data-testid="wf-primary-why" role={action.waiting ? 'status' : undefined}>{action.reason}</div> : null}
  </div>
);

export default WorkflowPrimaryBar;
